import React, { memo } from 'react'
import Snackbar from '.'
import useBehavior from './useBehavior'

const Context = React.createContext({
  open: false,
  handleClose: () => { },
  type: 'info',
  content: null
})

export const Provider = memo(({ children }) => {
  const behavior = useBehavior()

  return (
    <Context.Provider value={behavior}>
      <Snackbar
        onClose={behavior.handleClose}
        {...behavior}
      />
      {children}
    </Context.Provider>
  )
})

export default Context
